module.exports = __webpack_public_path__ + "static/graph-04f8b2f546da40785ae1c9cb8838afe0.svg";